// Veilles enregistrées (spec § 11) : critères repris des filtres de la liste des projets.

export type SavedSearchCriteria = {
  countries: string[];
  categories: string[];
  phases: string[];
  min_score: number | null;
  min_budget_eur: number | null;
};

const one = (value: unknown) =>
  typeof value === "string" && value ? [value] : [];

/** Critères d'une veille d'après les filtres en cours ; le masquage de « autre » n'en est pas un. */
export const criteriaFromFilters = (
  filters: Record<string, unknown>,
): SavedSearchCriteria => {
  const score = Number(filters["score@gte"]);
  return {
    countries: one(filters.country),
    categories: one(filters.category),
    phases: one(filters.phase),
    min_score: Number.isFinite(score) && score > 0 ? score : null,
    min_budget_eur: null,
  };
};

/** Même règle que la base : au moins un critère, sinon chaque fiche nouvelle déclencherait une alerte. */
export const hasCriterion = (criteria: SavedSearchCriteria) =>
  criteria.countries.length > 0 ||
  criteria.categories.length > 0 ||
  criteria.phases.length > 0 ||
  criteria.min_score != null ||
  criteria.min_budget_eur != null;
